export default "__VITE_ASSET__e6a98319__"